import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';

import App from '@/App';
import { ApiError } from '@/api/client';
import { SessionProvider } from '@/auth/session';
import '@/styles/tokens.css';
import '@/i18n';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A counter runs on patchy mobile data; two retries is the sweet spot
      // between recovering from a blip and leaving someone staring at a
      // spinner. Auth and permission failures never retry — the answer won't
      // change on a second attempt.
      retry: (failureCount, error) => {
        if (error instanceof ApiError) {
          if (error.isUnauthorized || error.isForbidden || error.status === 404) return false;
          if (error.isSubscriptionBlocked) return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: true,
      // The till gets backgrounded constantly; a reconnect should resync.
      refetchOnReconnect: true,
    },
    mutations: {
      retry: false,
    },
  },
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <SessionProvider>
          <App />
        </SessionProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
);